import { createTheme } from '@mui/material/styles';


//  #FAF3EA     beige foncé 
//  #FFFEF4     beige pale 
//  #D6621B     orange logo
//  #80B042     vert logo
//  #14A2DC     bleu logo
//  #20264C     texte logo


const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#D6621B',     // Bleu foncé
      contrastText: '#20264C',  //text primaire
    },
    secondary: {
      main: '#fff4f4ff',     // Orange
      contrastText: '#fff',
    },
    success: {
      main: '#80B042',     // Vert logo
    },
    background: {
      default: '#ffffff',  // Blanc cassé
     
    },
     menu: {
      main: '#FAF3EA',  // Blanc cassé
      paper: '#80B042',    // Jaune pâle
    },
    text: {
      primary: '#20264C',  // Bleu pour le texte
      secondary: '#D6621B',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    button: {
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          paddingLeft: 16,
          paddingRight: 16,
          boxShadow: 'none',
        },
        containedPrimary: {
          backgroundColor: '#80B042',
          color: '#fff',
          '&:hover': {
            backgroundColor: '#6a9236ff',
          },
        },
        containedSecondary: {
          backgroundColor: '#D56A2C',
          color: '#fff',
          '&:hover': {
            backgroundColor: '#b35821',
          },
        },
        containedThird: {
          backgroundColor: 'rgba(255, 255, 255, 0)',
          color: '#80B042',
          border: '1px solid #5f8131ff',
          '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0)',
                color: '#5f8131ff',
                border: '1px solid #5f8131ff',
          },
        },
        containedForth: {
          backgroundColor: 'rgba(255, 255, 255, 0)',
          color: '#80B042',       
          '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0)',
                color: '#5f8131ff',              
          },
        },
        containedFifth: {
          backgroundColor: '#20264C',
          color: '#ffffff',       
          '&:hover': {
                backgroundColor: '#20264C',
                color: '#ffffff', 
                boxShadow: '0px 4px 6px rgba(0,0,0,0.3)',              
          },
        },
        containedSuccess: {
          backgroundColor: '#4C8C2B',
          color: '#fff',
          '&:hover': {
            backgroundColor: '#3a6e20',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFEF4',
        },
      },
    },

    /********************** datepicker */
 MuiPickersDay: {
      styleOverrides: {
        root: {
          color: '#20264C', // couleur texte des jours
          backgroundColor: '#ffffff',
          '&:hover': {
            backgroundColor: '#c0c8ff',
            boxShadow: '0 0 8px rgba(32,38,76,0.6)',
          },
          '&.Mui-selected': {
            backgroundColor: '#20264C',
            color: '#fff',
            '&:hover': {
              backgroundColor: '#12183c',
              boxShadow: '0 0 12px rgba(32,38,76,0.8)',
            }
          }
        }
      }
    },
    MuiCalendarPicker: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff',
          // autre style possible ici
        }
      }
    },
    /********************** datepicker */


     /********************** DataGrid *************************/
      MuiDataGrid: {
        styleOverrides: {
          root: {
            backgroundColor: '#ffffff', // fond de la grille
            color: '#20264C', // couleur texte par défaut
            border: '1px solid #ccc',
          },
          columnHeaders: {
            backgroundColor: '#ffffff',
            color: '#20264C',
            fontWeight: 'bold',
          },
          menu: {
            backgroundColor: '#fff',
            color: '#20264C',
          },
          filterForm: {
            backgroundColor: '#fff',
            color: '#20264C',
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            backgroundColor: '#ffffff',
            '&.Mui-selected': {
              backgroundColor: '#5f8131ff',
              color: '#fff',
              '&:hover': {
                backgroundColor: '#5f8131ff',
              },
            },
            '&:hover': {
              backgroundColor: '#c0c8ff',
              color: '#20264C',
            },
          },
        },
      },
      MuiMenu: {
        styleOverrides: {
          paper: {
            backgroundColor: '#fff', // fond menu filtre
            color: '#20264C',        // texte menu filtre
          },
        },
      },

      MuiPopover: {
        styleOverrides: {
          paper: {
            backgroundColor: '#fff', // fond popover filtre
            color: '#20264C',
          },
        },
      },

      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundColor: '#FFFEF4',
            '&.MuiDataGrid-paper': {
              backgroundColor: '#fff',
              color: '#20264C',
            },
          },
        },
      },
    },

  
});

export default theme;
